import { Flex, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { OverviewCard } from '../../../../components/overview-card/overview-card';
import { ProgressBarCard } from '../../../../components/overview-card/progress-bar-card';
import { VerticalBarCard } from '../../../../components/overview-card/vertical-bar-card';
import { useStrategyStore } from '../../../../store/strategy-store/strategy-store';
import { skyDark } from '../../../../styles/design-tokens';
import { H3, Text } from '../../../../ui-library/typography/typography';
import { getStatusesData, getStatusesExtraData } from './overview.helpers';

export const Overview = () => {
  const i18n = useTranslation();
  const initiatives = useStrategyStore((state) => state.initiatives);
  const data = useStrategyStore((state) => state.kpiOverviewData);

  return (
    <Flex direction="row" gap={24}>
      <VerticalBarCard
        title={i18n.t('strategy.overview.by_status')}
        icon="insert_chart_outlined"
        data={getStatusesData(data, i18n.t)}
      />
      <VerticalBarCard
        title={i18n.t('strategy.overview.by_state')}
        icon="insert_chart_outlined"
        data={getStatusesExtraData(initiatives, i18n.t)}
      />
      <ProgressBarCard
        title={i18n.t('strategy.overview.completion')}
        icon="check_circle"
        value={data?.overall_completion || 0}
      />
      <OverviewCard
        title={i18n.t('strategy.overview.portfolio_throughput')}
        icon="show_chart"
        content={
          <Stack justify="center" align="center" gap={0} mt={10}>
            <H3>{data?.throughput || 0}</H3>
            <Text size="tiny" lineHeight="tight" color={skyDark}>
              {i18n.t('strategy.overview.tasks_completed', { work_units: i18n.t('common.work_units') })}
            </Text>
            <Text size="tiny" lineHeight="tight" color={skyDark}>
              {i18n.t('strategy.overview.last_30_days')}
            </Text>
          </Stack>
        }
      />
    </Flex>
  );
};
